// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"ac5740d5","453":"6833984f","881":"a17f53fa"}[chunkId] + ".chunk.js";
};